<div
  class="page-banner"
  [class.page-banner--info]="severity() === 'info'"
  [class.page-banner--warning]="severity() === 'warning'"
  [class.page-banner--error]="severity() === 'error'"
  role="status"
  aria-live="polite"
>
  <i
    class="pi"
    [class.pi-info-circle]="severity() === 'info'"
    [class.pi-exclamation-triangle]="severity() === 'warning'"
    [class.pi-times-circle]="severity() === 'error'"
    aria-hidden="true"
  ></i>
  <span class="page-banner__message">{{ message() }}</span>
  @if (actionLabel()) {
    <button
      type="button"
      class="page-banner__action"
      (click)="action.emit()"
    >
      {{ actionLabel() }}
    </button>
  }
  @if (dismissible()) {
    <button
      type="button"
      class="page-banner__dismiss"
      aria-label="Dismiss"
      (click)="dismissed.emit()"
    >
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  }
</div>
